import { InputRule } from '@tiptap/core';
import { InlineMath } from '@tiptap/extension-mathematics';

// Upstream's input rule is `/(?<!\$)(\$\$([^$\n]+?)\$\$)(?!\$)/`. Safari/iOS < 16.4
// cannot parse its lookbehind, so the editor throws on creation there (PLA-244).
// tiptap only calls `addInputRules` of the extension actually registered, so the
// upstream regex is never compiled. This rule consumes the preceding character
// instead of looking behind it, and starts the replacement after that character.
export const InlineMathWithoutLookbehind = InlineMath.extend({
	addInputRules() {
		return [
			new InputRule({
				find: /(?:^|[^$])(\$\$([^$\n]+?)\$\$)(?!\$)/,
				handler: ({ state, range, match }) => {
					const [fullMatch, mathMatch, latex] = match;
					const from = range.from + fullMatch.length - (mathMatch?.length ?? 0);
					state.tr.replaceWith(from, range.to, this.type.create({ latex }));
				},
			}),
		];
	},
});
